//3rd Party Components
import { createSelector } from 'reselect';

//expiry
export const expirySelector = (state, key) => state.envdata.items.systemsettings?.value.find(el => el.casa_name === key).casa_stringvalue;

export const getExpirySelector = createSelector(
    expirySelector,
    (expiry) => expiry
);


//feature
export const featureSelector = (state, key) => state.envdata.items.systemsettings?.value.find(el => el.casa_name === key).casa_stringvalue;

export const getFeatureSelector = createSelector(
    featureSelector,
    (feature) => feature
);


//url
export const urlSelector = (state, key) => state.envdata.items.systemsettings?.value.find(el => el.casa_name === key).casa_stringvalue;

export const getUrlSelector = createSelector(
    urlSelector,
    url => url
);


//snippets
const snippetSelector = (state, key) => state.envdata.items.snippets?.value.find(el => el.adx_name === key).adx_value;

export const getSnippetSelector = createSelector(
    snippetSelector,
    (snippet) => snippet
);


//system
const systemSelector = (state, key) => state.envdata.items.systemsettings?.value.find(el => el.casa_name === key).casa_stringvalue;

export const getSystemSelector = createSelector(
    systemSelector,
    (setting) => setting
);


//site
const siteSelector = (state, key) => state.envdata.items.sitesettings?.value.find(el => el.adx_name === key).adx_value;

export const getSiteSelector = createSelector(
    siteSelector,
    (setting) => setting
);